var _path, _path2, _g, _path3, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAnalisis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1437_74794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79791 2.65V12.4497H1.39896V2.65H0L2.10019 0.549805L4.20038 2.65H2.79791Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1437_74794)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1437_74794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -186,
    y: -19,
    width: 287,
    height: 186
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.109 -18.3516H-185.518V166.466H100.109V-18.3516Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1437_74794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9476 -1.19922H-1.75195V14.2034H5.9476V-1.19922Z",
    fill: "#7B7B7B"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1437_74794",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 10,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89844 8.95058V7.55162H9.80005V8.95058H4.89844ZM4.89844 12.4497V11.0508H7.69986V12.4497H4.89844ZM4.89844 5.44792V4.04896H11.9002V5.44792H4.89844ZM4.89844 1.94877V0.549805H14.0004V1.94877H4.89844Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1437_74794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7496 -1.2002H3.14844V14.2024H15.7496V-1.2002Z",
    fill: "#7B7B7B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalisis);
export default __webpack_public_path__ + "static/media/icon-analisis.c61290de.svg";
export { ForwardRef as ReactComponent };